module.exports = __webpack_public_path__ + "img/s4-title.176e4de3.png";